import { Service } from "./service"

export const InventoryLocationService = Service



// WEBPACK FOOTER //
// ./src/state/inventory/location/services/index.ts